import Flickity from "./flickityCarousel";
new Flickity();
